import React from "react";
import styles from "./RegModule.module.scss";
import TextField from "../../components/TextField/TextField";
import Button from "../../components/Button/Button";
import { Form, FormikProvider, useFormik } from "formik";
import { getPublicSettings, RegCredentials } from "../../ApiService";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

export type RegModuleProps = {
  title: string;
  credentials: RegCredentials;
  onSubmit: (values: RegCredentials) => void;
};

const RegModule: React.FC<RegModuleProps> = ({
  title,
  credentials,
  onSubmit,
}) => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: credentials,
    onSubmit: (values) => {
      const regAllowed =
        values.email && values.password && values.name && values.secret;
      if (regAllowed) {
        onSubmit(values);
      }
    },
  });
  const { data: settings } = useQuery("settings", getPublicSettings);

  const { values, handleChange } = formik;

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <FormikProvider value={formik}>
      <Form>
        <div className={styles.baseContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.fieldsContainer}>
            <TextField
              name="email"
              type="text"
              placeholder="Введите email"
              onChange={handleChange}
              value={values.email}
            />
            <TextField
              name="password"
              type="password"
              placeholder="Введите пароль"
              onChange={handleChange}
              value={values.password}
              autoComplete="password"
            />
            <TextField
              name="name"
              type="text"
              placeholder="Введите имя пользователя"
              onChange={handleChange}
              value={values.name}
            />
            <TextField
              name="secret"
              type="text"
              placeholder="Введите секреный код"
              onChange={handleChange}
              value={values.secret}
              autoComplete="off"
            />
          </div>

          <div className="flex flex-col items-center gap-4">
            <Button
              type="submit"
              title="Зарегистрироваться"
              size="large"
              style={{ width: "100%" }}
            />
            <div
              className="bodySemiboldFont text-purple-600 cursor-pointer"
              onClick={handleLogin}
            >
              Вход
            </div>
            {settings?.showAdminLink && (
              <a
                className="bodySemiboldFont text-purple-600 cursor-pointer"
                href={settings.adminLink}
                target="_blank"
                rel="noreferrer"
              >
                Помощь
              </a>
            )}
          </div>
        </div>
      </Form>
    </FormikProvider>
  );
};

export default RegModule;
